import styled from "styled-components";
import {
  MDBCard,
  MDBCardHeader,
  MDBCardTitle,
  MDBCardBody,
} from "mdb-react-ui-kit";
import { SidebarLayout } from "../common";
import { Row, Col } from "../App.styles";
import { Shimmer } from "../common/Loading.styles";

const CardRow = styled(Row)`
  margin-bottom: 2rem;
`;

const Card = styled(MDBCard)`
  padding: 0;
`;

const CardHeader = styled(MDBCardHeader)`
  background-color: #37474f;
`;

const CardTitle = styled(MDBCardTitle)`
  color: white;
`;

const ImageCol = styled(Col)`
  align-items: flex-start;
`;

const LibraryPlaceholder = () => {
  return (
    <Row>
      <SidebarLayout message={<Shimmer dark type="title" count={3} />}>
        <CardRow>
            <MDBCard>
                <MDBCardHeader>
                    <MDBCardTitle>
                        <Shimmer type="title" />
                    </MDBCardTitle>
                </MDBCardHeader>
                <MDBCardBody>
                    <Row>
                        <Col size="12" md="6">
                            <Shimmer type="title" count={3} />
                        </Col>
                        <Col size="12" md="6">
                            <Shimmer type="title" count={5} />
                        </Col>
                    </Row>
                    <Row>
                        <Shimmer type="title" count={5} />
                    </Row>
                    <Row>
                        <Card>
                            <CardHeader>
                                <CardTitle className="mb-0">
                                    <Shimmer type="cover" />
                                </CardTitle>
                            </CardHeader>
                            <MDBCardBody>
                                <Row>
                                    <ImageCol size="12" md="2" className="mb-2">
                                        <Shimmer media />
                                    </ImageCol>
                                    <Col size="12" md="10">
                                        <Shimmer type="title" count={5} />
                                    </Col>
                                </Row>
                                <Shimmer type="title" />
                            </MDBCardBody>
                        </Card>
                    </Row>
                </MDBCardBody>
            </MDBCard>
        </CardRow>
      </SidebarLayout>
    </Row>
  );
};

export default LibraryPlaceholder;
